import {useOrderStore} from '~/stores/order';
import {CustomerType} from '~/types/types';

const useOrderPayer = () => {
  const orderStore = useOrderStore()

  const orderLockState = computed(() => {
    return orderStore.orderForm.meta.lockState || {}
  })

  const isSegregated = computed(() => {
    return payer.value === 'segregated'
  })

  const isCloned = computed(() => {
    return !!useRoute().query.clone || false
  })

  const hasAnotherCurrency = computed(() => {
    return Object.keys(orderStore.orderTotalPrice?.currency?.list || {}).length > 1
  })

  const payer = computed({
    get() {
      return orderStore.orderForm.customer.payer
    },
    set(value: CustomerType) {
      if (value === 'segregated') {
        const list: any = {}
        orderStore.orderForm.customer.projectGuid = null
        orderStore.orderForm.services?.forEach((service) => {
          list[service.guid] = orderStore.orderForm.customer.payer
        })
        orderStore.orderForm.customer.segregated.list = list
      }
      orderStore.orderForm.customer.payer = value
      nextTick().then(() => {
        if (hasAnotherCurrency.value) {
          // Для получение дефолт валюты
          orderStore.getOrderPriceAction()
        }
      })
    }
  })

  return {
    orderLockState,
    isSegregated,
    isCloned,
    payer
  }
}

export default useOrderPayer
